import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, setAnalyticsCollectionEnabled } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

let analyticsInstance = null;
let analyticsInitPromise = null;

export async function getAnalyticsInstance() {
  if (analyticsInstance) return analyticsInstance;
  if (analyticsInitPromise) return analyticsInitPromise;

  analyticsInitPromise = (async () => {
    const supported = await isSupported();
    if (!supported) return null;

    const analytics = getAnalytics(firebaseApp);
    setAnalyticsCollectionEnabled(analytics, true);

    // Force debug mode in local development for DebugView
    if (window.location.hostname === 'localhost') {
      window.localStorage.setItem('debug_mode', 'true');
      window.sessionStorage.setItem('debug_mode', 'true');
    }

    analyticsInstance = analytics;
    return analyticsInstance;
  })();

  return analyticsInitPromise;
}

export async function trackEvent(eventName, params = {}) {
  try {
    const analytics = await getAnalyticsInstance();
    if (!analytics) return;

    const finalParams =
      window.location.hostname === 'localhost'
        ? { ...params, debug_mode: true }
        : params;

    logEvent(analytics, eventName, finalParams);
    console.log('[analytics]', eventName, finalParams);
  } catch (error) {
    console.error('Analytics event failed:', eventName, error);
  }
}